import { useState } from "react";
import { ActionModal, FIELD_LABEL_CLASS, INPUT_CLASS } from "./ActionModal";

/** Raise / reset the proof requirement (§5.2): integer ≥ 1, or empty to
 *  return to the default. */
export function ProofRequirementModal({
  current,
  onSubmit,
  onClose,
  pending,
}: {
  current: number;
  onSubmit: (body: { count: number | null; reason: string }) => void;
  onClose: () => void;
  pending?: boolean;
}) {
  const [countText, setCountText] = useState(String(current));
  const [reason, setReason] = useState("");

  const trimmed = countText.trim();
  const parsed = trimmed === "" ? null : Number(trimmed);
  const valid =
    parsed === null || (Number.isInteger(parsed) && parsed >= 1);

  return (
    <ActionModal
      title="Proof requirement"
      submitLabel="Save requirement"
      onSubmit={() => onSubmit({ count: parsed, reason: reason.trim() })}
      onClose={onClose}
      pending={pending}
      disabled={!valid || !reason.trim()}
    >
      <div>
        <label className={FIELD_LABEL_CLASS}>
          Qualifying bookings required (empty = back to default)
        </label>
        <input
          type="number"
          min={1}
          step={1}
          className={INPUT_CLASS}
          value={countText}
          onChange={(e) => setCountText(e.target.value)}
        />
        {!valid && (
          <p className="text-xs text-red-600 mt-1">
            Must be a whole number ≥ 1, or empty for the default.
          </p>
        )}
      </div>
      <div>
        <label className={FIELD_LABEL_CLASS}>Reason (required)</label>
        <textarea
          className={`${INPUT_CLASS} min-h-[66px]`}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
      </div>
      <p className="text-xs text-gray-400">
        A raised requirement withholds promotion until met and feeds the
        30-day minimum-fee referral.
      </p>
    </ActionModal>
  );
}
